import {Stack, styled, Typography} from '@mui/material';
import {Colors} from '@constants/colors.constants';
import {NumberExt} from '@utils/extensions/number.extension';
import {useObservable} from '@ngneat/react-rxjs';
import {statisticsQuery} from '@store/statistics';
import {NorthEast, SouthEast} from '@mui/icons-material';

const MostProfitableClientsChart = () => {

  const [{clientsTurnover, loading}] = useObservable(statisticsQuery.mostProfitableClients$);

  const SlideSize = 350;

  if (!clientsTurnover) {
    return <></>;
  }

  const Slider = styled(Stack)`
      @keyframes scroll {
          0% {
              transform: translateX(0);
          }
          100% {
              transform: translateX(calc(-${SlideSize}px * ${clientsTurnover.length}));
          }
      }
      height: 125px;
      overflow: hidden;
      position: relative;
      width: calc(${SlideSize}px * ${clientsTurnover.length * 2});

      ::before,
      ::after {

          content: "";
          height: 125px;
          position: absolute;
          width: ${SlideSize}px;
          z-index: 2;
      }

      ::after {
          right: 0;
          top: 0;
          transform: rotateZ(180deg);
      }

      ::before {
          left: 0;
          top: 0;
      }
  `;

  const SlideTrack = styled(Stack)`
      animation: scroll 40s linear infinite;
      display: flex;
      width: 100%;
      flex-direction: row;
      align-items: center;
  `;

  const Slide = styled(Stack)`
      height: 125px;
      width: ${SlideSize}px;
      padding: 0 10px;
  `;

  return (
    <>
      {!loading && (clientsTurnover?.length || 0) > 0 && <Slider>
          <SlideTrack>
            {clientsTurnover?.map((client, index) => (<Slide key={client.id}>
              <Stack direction="row" spacing={2} flex={1}>
                <Typography fontSize={75} fontWeight={400} color={Colors.primary}
                            style={{opacity: 0.8}}>{index + 1}.</Typography>
                <Stack direction="column">
                  <Stack flex={0.5} justifyContent="flex-end">
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography fontSize={30}
                                  fontWeight="bold">{NumberExt.nFormatter(client.totalAmountNoVatInCents / 100, 1)}</Typography>
                      <Stack spacing={1} direction="row" alignItems="center"
                             sx={{
                               padding: '4px',
                               borderRadius: '4px',
                               backgroundColor: Colors.white,
                               color: client.percentVariation == null ? Colors.black : client.variation > 0 ? Colors.success : Colors.error
                             }}>
                        {client.percentVariation === null ? <></> : client.variation > 0 ? <NorthEast/> : <SouthEast/>}
                        <Typography
                          fontSize={15}>{client.percentVariation == null ? 'N/A' : `${NumberExt.nFormatter(client.variation / 100, 1)} (${Math.round(client.percentVariation)}%)`}</Typography>
                      </Stack>
                    </Stack>

                  </Stack>
                  <Stack flex={0.5} justifyContent="flex-start">
                    <Typography sx={{lineHeight: 1.5}} fontSize={15}>{client.name}</Typography>
                  </Stack>
                </Stack>

              </Stack>
            </Slide>))}
            {clientsTurnover?.map((client, index) => (<Slide key={'1' + client.id}>
              <Stack direction="row" spacing={2} flex={1}>
                <Typography fontSize={75} fontWeight={400} color={Colors.primary}
                            style={{opacity: 0.8}}>{index + 1}.</Typography>
                <Stack direction="column">
                  <Stack flex={0.5} justifyContent="flex-end">
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography fontSize={30}
                                  fontWeight="bold">{NumberExt.nFormatter(client.totalAmountNoVatInCents / 100, 1)}</Typography>
                      <Stack spacing={1} direction="row" alignItems="center"
                             sx={{
                               padding: '4px',
                               backgroundColor: Colors.white,
                               color: client.percentVariation == null ? Colors.black : client.variation > 0 ? Colors.success : Colors.error
                             }}>
                        {client.percentVariation === null ? <></> : client.variation > 0 ? <NorthEast/> : <SouthEast/>}
                        <Typography
                          fontSize={15}>{client.percentVariation == null ? 'N/A' : `${NumberExt.nFormatter(client.variation / 100, 1)} (${Math.round(client.percentVariation)}%)`}</Typography>
                      </Stack>
                    </Stack>

                  </Stack>
                  <Stack flex={0.5} justifyContent="flex-start">
                    <Typography sx={{lineHeight: 1.5}} fontSize={15}>{client.name}</Typography>
                  </Stack>
                </Stack>

              </Stack>
            </Slide>))}
          </SlideTrack>
      </Slider>
      }
    </>
  );
};

export default MostProfitableClientsChart;
